import { controls, currencyToNumber, grouped } from "../../controls";

const rpdrp2 = {
  label: "Performa 2",
  starting: true,
  url: "rp101m",
  pageLabel: "Performa 2",
  pageType: "history",
  visitingBranches: true,
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Bank" }),
    ...controls.oc({ tab: "filter", c: "Bank", placeHolder: "Bank Code", name: "bank_code", defaultValue: "assigned_bank", fastpath: "banks" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "bank_display" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Performa 2",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Bank",
        accessor: "bank",
        rwidth: "*"
      },
      {
        Header: "TOTAL Loan",
        columns: [
          {
            Header: "Accounts",
            accessor: "total_loan_ac",
          },
          {
            Header: "Outstanding",
            accessor: "total_outstanding",
            type: 'currency'
          },
          {
            Header: "Eligible Accounts",
            accessor: "tot_eligible_ac",
          },
          {
            Header: "Eligible Amount",
            accessor: "tot_eligible_amount",
            type: 'currency'
          },
        ]
      },

      {
        Header: "Sale Case",
        columns: [
          {
            Header: "Count",
            accessor: "sale_case_cnt",
          },
          {
            Header: "Amount",
            accessor: "sale_case_amt",
            type: 'currency'
          }
        ]
      },
      {
        Header: "Under NIA Sec 138",
        columns: [
          {
            Header: "Count",
            accessor: "case_under_nia_cnt",
          },
          {
            Header: "Amount",
            accessor: "case_under_nia_amt",
            type: 'currency'
          }
        ]
      },
      {
        Header: "Other Cases",
        columns: [
          {
            Header: "Count",
            accessor: "other_case_cnt",
          },
          {
            Header: "Amount",
            accessor: "other_case_amt",
            type: 'currency'
          }
        ]
      },
      {
        Header: "Notices Issued",
        columns: [
          {
            Header: "Count",
            accessor: "notice_issued_cnt",
          },
          {
            Header: "Amount",
            accessor: "notice_issued_amt",
            type: 'currency'
          }
        ]
      },
      {
        Header: "TOTAL NPA",
        accessor: "total",
        formula: [{
          f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'sale_case_amt' }, { source: 'row', field: 'case_under_nia_amt' }, { source: 'row', field: 'other_case_amt' }, { source: 'row', field: 'notice_issued_amt' }
          ], resultVar: 'total'
        }],
        type: 'currency'
      }
    ]
  }
};

export default rpdrp2;